import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // iPad縦
      "@media (min-width: 1000px)": {
        width: "90.5%",
      },
      // iPad横
      "@media (min-width: 1150px)": {
        width: "92.3%",
      },
      // GWPC
      "@media (min-width: 1200px)": {
        width: "93%",
      },
    },
    firstRowCell: {
      width: "1%",
      padding: "6px 0px",
    },
    secondRowCell: {
      "@media (min-width: 1000px)": {
        width: "11.5%",
      },
      "@media (min-width: 1150px)": {
        width: "9.3%",
      },
      "@media (min-width: 1200px)": {
        width: "7.8%",
      },
      padding: "6px 3px",
      fontSize: "11px",
      fontWeight: "bold",
      wordBreak: "keep-all",
    },
    secondRowCellCVR: {
      "@media (min-width: 1000px)": {
        width: "10.5%",
      },
      "@media (min-width: 1150px)": {
        width: "9.2%",
      },
      "@media (min-width: 1200px)": {
        width: "7.8%",
      },
      padding: "6px 3px",
      fontSize: "11px",
      fontWeight: "bold",
      wordBreak: "keep-all",
    },
    infoTipCell: {
      padding: "0px 3px",
    },
    cell: {
      padding: "2px",
      fontSize: "9px",
    },
    col: {
      padding: "1px",
      backgroundColor: "#ececec",
      whiteSpace: "pre",
    },
    firstTargetColor: {
      color: "#0000FF",
      fontSize: "20px",
    },
    secondTargetColor: {
      color: "#00B050",
      fontSize: "20px",
    },
  })
);

const diffColor = (value: number) => {
  if (value > 0) {
    return "#0000FF";
  } else if (value === 0) {
    return "";
  } else if (value < 0) {
    return "#FF0000";
  }
};

const TableContent: React.FC<{
  data: any;
  graphType: string;
  baseAxis: number;
  firstDate: string;
  holiday: string[];
  today: string;
}> = ({ data, graphType, baseAxis, firstDate, holiday, today }) => {
  const classes = useStyles();
  const dateList = React.useRef<string[]>([]);
  const holidayList = React.useRef<string[]>([]);
  let countItem = 1;
  if (data !== undefined) {
    countItem = data.length;
  }
  const adjustWidth = 86 / countItem + "%";

  const makeDateList = () => {
    const tempDateList = [];
    const tempHolidayList = [];
    const year = firstDate.slice(0, 4);
    const month = firstDate.slice(4, 6);
    const day = firstDate.slice(6, 8);
    const dateStr = `${year}/${month}/${day}`;
    const standardDate = new Date(dateStr);
    const start = new Date(standardDate.setDate(standardDate.getDate() - 14));
    const end = new Date(standardDate.setDate(standardDate.getDate() + 28));
    for (let d = start; d <= end; d.setDate(d.getDate() + 1)) {
      let formatedDate = `${d.getFullYear()}/${
        d.getMonth() + 1
      }/${d.getDate()}`;
      const month = ("0" + (d.getMonth() + 1)).slice(-2);
      const date = ("0" + d.getDate()).slice(-2);
      let formatedHoliday = `${d.getFullYear()}${month}${date}`;
      tempDateList.push(formatedDate);
      tempHolidayList.push(formatedHoliday);
    }
    dateList.current = tempDateList;
    holidayList.current = tempHolidayList;
  };

  const checkHoliday = (index: number) => {
    if (baseAxis !== 1) return;
    const date = new Date(dateList.current[index]);
    if (date.getDay() === 0 || holiday.includes(holidayList.current[index])) {
      if (holiday.includes(holidayList.current[index])) {
      }
      return "red";
    } else if (date.getDay() === 6) {
      return "blue";
    }
  };

  const getWeekDay = (index: number) => {
    const week = ["日", "月", "火", "水", "木", "金", "土"];
    const date = new Date(dateList.current[index]);
    const weekDayNum = date.getDay();
    return week[weekDayNum];
  };

  const makeFutureTable = () => {
    const selectedDate = convertDate(firstDate);
    const twoWeekAgoDate = new Date(
      selectedDate.setDate(selectedDate.getDate() - 14)
    );
    const todayDate = convertDate(today);
    let dateDiff =
      (todayDate.getTime() - convertDate(firstDate).getTime()) / 86400000;
    if (todayDate > twoWeekAgoDate) {
      for (let d = 15 + dateDiff; d < 29; d++) {
        data[d].firstTenpoRealNumForTable = "-";
        data[d].secondTenpoRealNumForTable = "-";
        data[d].firstMobakuRealNumForTable = "-";
        data[d].secondMobakuRealNumForTable = "-";
        data[d].diffForTable = "-";
      }
    }
  };

  const convertDate = (date: string) => {
    const year = date.slice(0, 4);
    const month = date.slice(4, 6);
    const day = date.slice(6, 8);
    const dateStr = `${year}/${month}/${day}`;
    return new Date(dateStr);
  };

  baseAxis === 1 && makeDateList();
  if (data) {
    baseAxis === 1 && data.length === 29 && makeFutureTable();
  }

  return (
    <>
      {data && (
        <Table className={classes.root} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.firstRowCell}></TableCell>
              <TableCell
                className={classes.infoTipCell}
                style={{ width: "5.5%" }}
              ></TableCell>
              {data.map((data: any, index: number) => (
                <TableCell
                  className={classes.col}
                  align="center"
                  key={index.toString()}
                  style={
                    baseAxis === 1 && data.date.length > 2
                      ? { color: checkHoliday(index), lineHeight: "1" }
                      : { lineHeight: "2" }
                  }
                >
                  {data.date}
                  <br />
                  {baseAxis === 1 &&
                    data.date.length > 2 &&
                    `(${getWeekDay(index)})`}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {graphType === "tenpo" && (
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.firstTargetColor}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  客数当年実数
                  <br />
                  （人）
                </TableCell>
                {data.map((data: any, index: string) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.firstTenpoRealNumForTable}
                  </TableCell>
                ))}
              </TableRow>
            )}
            {graphType === "tenpo" && (
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.secondTargetColor}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  客数当年実数
                  <br />
                  （人）
                </TableCell>
                {data.map((data: any, index: string) => (
                  <TableCell
                    className={classes.cell}
                    align="center"
                    key={index.toString()}
                  >
                    {data.secondTenpoRealNumForTable}
                  </TableCell>
                ))}
              </TableRow>
            )}
            {graphType === "mobaku" && (
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.firstTargetColor}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  モバ空当年実数
                  <br />
                  （千人）
                </TableCell>
                {data.map((data: any, index: string) => (
                  <TableCell
                    className={classes.cell}
                    style={{ width: adjustWidth }}
                    align="center"
                    key={index.toString()}
                  >
                    {data.firstMobakuRealNumForTable}
                  </TableCell>
                ))}
              </TableRow>
            )}
            {graphType === "mobaku" && (
              <TableRow>
                <TableCell className={classes.firstRowCell}>
                  <span className={classes.secondTargetColor}>●</span>
                </TableCell>
                <TableCell className={classes.secondRowCell} align="left">
                  モバ空当年実数
                  <br />
                  （千人）
                </TableCell>
                {data.map((data: any, index: string) => (
                  <TableCell
                    className={classes.cell}
                    style={{ width: adjustWidth }}
                    align="center"
                    key={index.toString()}
                  >
                    {data.secondMobakuRealNumForTable}
                  </TableCell>
                ))}
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.firstRowCell}></TableCell>
              <TableCell className={classes.secondRowCell} align="left">
                差
              </TableCell>
              {data.map((data: any, index: string) => (
                <TableCell
                  className={classes.cell}
                  align="center"
                  key={index.toString()}
                  style={{
                    color:
                      data.diffForTable != null
                        ? diffColor(Number(data.diffForTable.replace(/,/, "")))
                        : "",
                    width: adjustWidth,
                  }}
                >
                  {data.diffForTable}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default TableContent;
